<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12 sm12 lg10 offset-lg1 xl8 offset-xl2>
        <h1 class="display-1 my-4 text-xs-center">{{ post.title }}</h1>
        <v-card class="mt-5">
          <v-img
            v-if="post.media[0].card_url"
            :src="post.media[0].card_url"
            :aspect-ratio="16 / 9"
          >
            <v-layout
              slot="placeholder"
              fill-height
              align-center
              justify-center
              ma-0
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-layout>
          </v-img>
          <v-card-title primary-title>
            <div>
              <h2 class="headline pr-2">{{ post.title }}</h2>
              <h3 class="subheading grey--text">{{ post.subtitle }}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-html="post.body"></div>
            <div class="text-xs-right pa-3 font-weight-light">
              <AppDate
                :timestamp="new Date(post.published_on).getTime() / 1000"
              ></AppDate>
            </div>
          </v-card-text>
          <v-card-actions>
            <AppSocialShare></AppSocialShare>
            <v-spacer></v-spacer>
            <v-btn flat color="info" @click="$router.push({ name: 'blog' })">
              Back
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-alert
          :value="postError"
          color="error"
          icon="fas fa-exclamation-triangle"
          outline
          class="mt-3"
          role="alert"
        >
          {{ postError }}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { getPost } from '../api/posts';
import AppDate from '../components/AppDate';
import AppSocialShare from '../components/AppSocialShare';

export default {
  name: 'Post',
  metaInfo: {
    title: 'Blog Post',
  },
  components: {
    AppDate,
    AppSocialShare,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      postError: 'postError',
      post: 'post',
    }),
  },
  created() {
    this.getPost();
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    getPost() {
      this.$store.dispatch('post');
      getPost(this.slug)
        .then((res) => {
          this.$store.commit('postSuccess', res);
          this.postSuccess();
        })
        .catch((error) => {
          this.postFailed();
          this.$store.commit('postFailed', { error });
        });
    },
    postSuccess() {
      this.showSnackbar({
        text: 'Post loaded successfully!',
        color: 'success',
        timeout: 5000,
      });
    },
    postFailed() {
      this.showSnackbar({
        text: 'There was a problem with getting the post!',
        color: 'warning',
        timeout: 5000,
      });
    },
  },
};
</script>
